import { COLORS } from '../../../style/colors'
import { ActivityStatusConfig } from './useActivityStatuses.types'

export const ACTIVITY_STATUSES: Record<string, ActivityStatusConfig[]> = {
    COMMON: [
        {
            id: 'Ideation',
            name: 'Ideation',
            shape: 'circle',
            color: COLORS.brightSun,
            order: -1,
        },
        {
            id: 'Planned',
            name: 'Planned',
            shape: 'triangle-down',
            color: COLORS.butterflyBlue,
            order: 0,
        },
        {
            id: 'Initiated',
            name: 'Initiated',
            shape: 'triangle-up',
            color: COLORS.sunshade,
            order: 1,
        },
        {
            id: 'On Hold',
            name: 'On Hold',
            shape: 'diamond',
            color: COLORS.purpleHeart,
            order: 2,
        },
        {
            id: 'Cancelled',
            name: 'Cancelled',
            shape: 'square',
            color: COLORS.lipstickRed,
            order: 3,
        },
        {
            id: 'Completed',
            name: 'Completed',
            shape: 'circle',
            color: COLORS.caribbeanGreen,
            order: 4,
        },
    ],
    SANOFI: [
        {
            id: 'Ideation',
            name: 'Ideation',
            shape: 'square',
            color: COLORS.brightSun,
            order: -1,
        },
        {
            id: 'Planned',
            name: 'Planned',
            shape: 'square',
            color: COLORS.sanofiActivityPlanned,
            order: 0,
        },
        {
            id: 'Initiated',
            name: 'Ongoing',
            shape: 'square',
            color: COLORS.sanofiActivityInitiated,
            order: 1,
        },
        {
            id: 'On Hold',
            name: 'On-hold',
            shape: 'square',
            color: COLORS.sanofiActivityOnHold,
            order: 2,
        },
        {
            id: 'Cancelled',
            name: 'Cancelled',
            shape: 'square',
            color: COLORS.sanofiActivityCancelled,
            order: 3,
        },
        {
            id: 'Completed',
            name: 'Completed',
            shape: 'square',
            color: COLORS.sanofiActivityCompleted,
            order: 4,
        },
    ],
    OTSUKA: [
        {
            id: 'Ideation',
            name: 'Ideation',
            shape: 'circle',
            color: COLORS.brightSun,
            order: -1,
        },
        {
            id: 'Proposed',
            name: 'Proposed',
            color: COLORS.lavender,
            shape: 'triangle-up',
            order: 0,
        },
        {
            id: 'On Hold',
            name: 'On-Hold',
            shape: 'diamond',
            color: COLORS.sunshade,
            order: 1,
        },
        {
            id: 'Planned',
            name: 'Planned',
            shape: 'triangle-down',
            color: COLORS.butterflyBlue,
            order: 2,
        },
        {
            id: 'Cancelled',
            name: 'Cancelled',
            shape: 'square',
            color: COLORS.lipstickRed,
            order: 3,
        },
        {
            id: 'Initiated',
            name: 'Active',
            shape: 'pentagon',
            color: COLORS.magenta,
            order: 4,
        },
        {
            id: 'Terminated',
            name: 'Terminated',
            color: COLORS.granite,
            shape: 'hexagon',
            order: 5,
        },
        {
            id: 'Completed',
            name: 'Completed',
            shape: 'circle',
            color: COLORS.caribbeanGreen,
            order: 6,
        },
    ],
    NN: [
        {
            id: 'Ideation',
            name: 'Ideation',
            shape: 'circle',
            color: COLORS.brightSun,
            order: -1,
        },
        {
            id: 'Planned',
            name: 'Proposed',
            shape: 'triangle-down',
            color: COLORS.butterflyBlue,
            order: 0,
        },
        {
            id: 'Initiated',
            name: 'Ongoing',
            shape: 'triangle-up',
            color: COLORS.sunshade,
            order: 1,
        },
        {
            id: 'On Hold',
            name: 'On Hold',
            shape: 'diamond',
            color: COLORS.purpleHeart,
            order: 2,
        },
        {
            id: 'Cancelled',
            name: 'Cancelled',
            shape: 'square',
            color: COLORS.lipstickRed,
            order: 3,
        },
        {
            id: 'Completed',
            name: 'Completed',
            shape: 'circle',
            color: COLORS.caribbeanGreen,
            order: 4,
        },
    ],
}
